import {Controller} from '@hotwired/stimulus';
import $ from "jquery";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'uploadContainer',
        'infoContainer',
        'fileInput',
        'fileName',
    ];

    fileUpload() {
        $(this.uploadContainerTarget).css('display', 'none')
        $(this.infoContainerTarget).css('display', 'block')
        $(this.fileNameTarget).text(this.fileInputTarget.files.item(0).name);

        addAlert('success', translations['payment_popup.Document added successfully']);
    }

    fileRemove(event) {
        $(this.uploadContainerTarget).css('display', 'block');
        $(this.infoContainerTarget).css('display', 'none');
        $(this.fileInputTarget).val(null);
        $(this.fileNameTarget).text('');

        addAlert('success', translations['payment_popup.Document deleted successfully']);
    }
}
